import { remove } from 'es-cookie'
import getHostname from '@awork/_shared/functions/get-hostname'

const DATADOG_SESSION_COOKIE_NAME = '_dd_s'

/**
 * Removes the domain-scoped Datadog session cookie left by cross-subdomain tracking.
 * Host-scoped cookies with the same name are not affected by this removal.
 * @param {typeof remove} [removeCookie=remove]
 * @param {string} [domain=getHostname()]
 */
export function removeDatadogCrossSubdomainSessionCookie(
  removeCookie: typeof remove = remove,
  domain: string = getHostname()
): void {
  removeCookie(DATADOG_SESSION_COOKIE_NAME, { domain, path: '/' })
}
